import { normalize } from "common/lib/normalize";
import { getAgencies } from "common/services/agencies.service";
import React, { useEffect, useMemo } from "react";
import Select from "react-select";

type AgencyFilterProps = {
  onChange: (value: any) => void;
  value: any;
};

const AgencyFilter = ({ onChange, value }: AgencyFilterProps) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor: "#ced4da",
      "&:hover": {
        borderColor: "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: any = await getAgencies({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
          filters: {
            category: {
              $null: false,
            },
          },
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  // Alphabetical, A to Z. Sorted here rather than by the API so case and
  // accents do not split the order ("unicef" sits with "UNICEF").
  const options = useMemo(() => {
    return data
      .map((el: any) => {
        return {
          value: el?.id,
          label: el?.name,
        };
      })
      .sort((a: any, b: any) =>
        (a.label ?? "").localeCompare(b.label ?? "", undefined, {
          sensitivity: "base",
        })
      );
  }, [data]);

  return (
    <Select
      name="agency"
      id="agency"
      isSearchable
      isClearable
      placeholder="Select agency"
      onChange={onChange}
      options={options}
      value={value}
      // onBlur={() => validation.setFieldTouched("mda", true)}
      styles={customSelectStyles}
      loading={loading}
    />
  );
};

export default AgencyFilter;
